import React, { useEffect, useState } from "react";
import { getTermList, getTermInfo, getTerm, IGetTermResponse } from "api/common/Auth.api";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import TermsComponent from './Terms.component';

const TermsContainer = (props: any) => {
  const [termList, setTermList] = useState([]);
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [isInit, setIsInit] = useState(false);
  const [info, setInfo] = useState(null);
  const [list, setList] = useState([]); // 약관 목록

  const getTermListValue = async () => {
    const result = await getTermList({});

    console.log(result);
    if (result) {
      const list = result.list.filter((item: any) => item !== null)
      setTermList(list);
      setIsInit(true);
    }
  };

  const getInfo = async () => {
    // const item = termList.find((item: any) => item?.id === Number(params.termsId));

    try {
      const result = await getTerm(Number(params.termsId)) as IGetTermResponse;
      if (result) {
        setInfo(result?.info);
        setList(result?.list);
      } else {
        navigate("/agency/my");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsInit(true);
    }
  };

  const getTermInfoValue = async () => {
    const result = await getTermInfo(Number(params.termsId));

    console.log(result);

    if (result) {
      setInfo(result?.info);
    }
  };

  useEffect(() => {
    console.log(location);

    if (location.pathname.includes("my/terms")) {
      getTermListValue();
    } else {
      getTermInfoValue();
    }
  }, []);

  useEffect(() => {
    if (isInit) {
      getInfo();
    }
  }, [isInit, params]);

  return <TermsComponent info={info} list={list} {...props} />;
};

export default TermsContainer;
